import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import Layout from '../layout/layout';
import { getPair, getRole, getToken, savePair } from '../localStorage';
import Accounts from '../pages/accounts/accounts';
import Decisions from '../pages/monitorizations/monitorizations';
import Home from '../pages/home/home';
import Institution from '../pages/institution/institution';
import Legislation from '../pages/legislation/legislation';
import Notifications from '../pages/notifications/notifications';
import LitigationNotifications from '../pages/notifications/litigationNotifications';
import AuditNotifications from '../pages/notifications/auditNotifications';
import DefaultNotifications from '../pages/notifications/defaultNotifications';

import Raports from '../pages/raports/raports';
import RedirectingPage from '../pages/redirect';
import LegislationAdmin from '../pages/admin/manage-legislation/legislation';
import NotificationsAdmin from '../pages/admin/manage-notifications/notifications';
import { RootState } from '../redux';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { hydrate } from '../redux/reducers/session';
import { ROUTES } from './routes';
import { types_users } from '../types/users';
import AccountsAdmin from '../pages/admin/manage-accounts/accounts';
import Decision from '../pages/monitorization/monitorization';
import { generate_pair } from '../utils/auth';
import AdministrateRaports from '../pages/administration-institutions/administration-raports';
import AdministrateMonitorizations from '../pages/administration-institutions/administration-monitorizations';
import Tutorial from '../pages/tutorial/tutorial';
import PDFViewer from '../components/pdf-viewer/pdf-viewer';
import Litigii from '../pages/litigii/litigii';
import Achizitii from '../pages/achizitii/achizitii';
import RedirectingPageAccept from '../pages/redirect/redirect-accept-request';
import RedirectingPageReject from '../pages/redirect/redirect-reject-request';
import LitigiiDetails from '../pages/litigii-details/litigii-details';
import PrivacyPolicy from '../pages/privacy-policy/privacy-policy';
import TermsAndConditions from '../pages/terms-and-conditions/terms-and-conditions';
import DataProcessingAgreement from '../pages/data-processing-agreement/data-processing-agreement';
import CcrReport from '../components/ccr-report/ccr-report';
import Login from '../pages/login/login';
import useCurrentSession from '../redux/useCurrentSession';
import ForgotPassword from '../pages/forgotPassword/forgotPassword';
import ResetPassword from '../pages/resetPassword/resetPassword';
import Calendar from '../pages/litigii/calendar';
import { useCurrentSessionQuery, useGetCurrentUserQuery } from '../api';
import { useSelector } from 'react-redux';
import { disableLoader, enableLoader } from '../components/loader/loader';
import LitigationDocument from '../components/litigation-dicument/litigation-document';

const RoleGuardedRoute = (props: any) => {
  const { component, isLogged, canVisit, type, ...rest } = props;
  const Component = props.component;

  return (
    <Route
      {...rest}
      render={() => {
        if (isLogged && canVisit) {
          return <Component {...props} />;
        }
        return <Redirect to='/' />;
      }}
    />
  );
};

const Router = () => {
  useCurrentSession();

  const dispatch = useAppDispatch();
  const id = useAppSelector((state: RootState) => state.session.id);
  const { isLoggedIn, isLoading } = useSelector(
    (state: RootState) => state.session
  );
  const session = getToken();
  const role = getRole();

  const isPrincipalAccount = role === types_users.principal;
  const isAdmin = role === types_users.admin;
  const isSecondaryAccount = role === types_users.secondary;
  const { data: user } = useGetCurrentUserQuery();

  useEffect(() => {
    if (isLoading) {
      enableLoader();
    } else {
      disableLoader();
    }
  }, [isLoading]);

  if (isLoading && window.location.pathname !== ROUTES.LOGIN) {
    return null;
  }

  return (
    <BrowserRouter>
      <Layout>
        <Switch>
          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            exact
            path={ROUTES.INSTITUTION}
            component={Institution}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            exact
            path={ROUTES.REPORTS}
            component={Raports}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            exact
            path={ROUTES.DECISIONS}
            component={Decisions}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount}
            exact
            path={ROUTES.ACCOUNTS}
            component={Accounts}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={
              isPrincipalAccount ||
              (isSecondaryAccount && user?.publicAcquisitions)
            }
            exact
            path={ROUTES.ACHIZITII}
            component={Achizitii}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            exact
            path={ROUTES.NOTIFICATIONS}
            component={DefaultNotifications}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            exact
            path={ROUTES.LITIGATION_NOTIFICATIONS}
            component={LitigationNotifications}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            exact
            path={ROUTES.AUDITS_NOTIFICATIONS}
            component={AuditNotifications}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            exact
            path={ROUTES.CALENDAR}
            component={Calendar}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            exact
            path={ROUTES.LEGISLATION}
            component={Legislation}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount}
            exact
            path={ROUTES.ADMIN_DECISIONS}
            component={AdministrateMonitorizations}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount}
            exact
            path={ROUTES.ADMIN_REPORTS}
            component={AdministrateRaports}
          />
          {/* <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount}
            exact
            path={ROUTES.ADD_DECISION}
            component={AddDecision}
          /> */}
          <RoleGuardedRoute
            isLogged={!!session}
            canVisit
            exact
            path={ROUTES.DECISION}
            component={Decision}
          />

          {/* <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount}
            exact
            path={ROUTES.LOGIN}
            component={Login}
          >
          
          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount}
            exact
            path={ROUTES.CHANGE_PASS}
          >
            <ChangePass />
          </RoleGuardedRoute> */}
          <Route exact path={ROUTES.LOGIN}>
            <Login />
          </Route>
          <Route exact path={ROUTES.FORGOT_PASSWORD}>
            <ForgotPassword />
          </Route>
          <Route exact path={ROUTES.RESET_PASSWORD}>
            <ResetPassword />
          </Route>

          <Route exact path={ROUTES.HOME}>
            <Home />
          </Route>
          <Route exact path={ROUTES.TUTORIAL}>
            <Tutorial />
          </Route>
          <Route exact path={ROUTES.PRIVACY_POLICY}>
            <PrivacyPolicy />
          </Route>
          <Route exact path={ROUTES.TERMS_AND_CONDITIONS}>
            <TermsAndConditions />
          </Route>
          <Route exact path={ROUTES.DATA_PROCESSING_AGREEMENT}>
            <DataProcessingAgreement />
          </Route>

          <Route exact path={ROUTES.PDF}>
            <PDFViewer />
          </Route>

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            path={ROUTES.LITIGII_DETAILS}
            component={LitigiiDetails}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            path={ROUTES.LITIGII}
            component={Litigii}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            path={ROUTES.REDIRECT}
            component={RedirectingPage}
          />

          <RoleGuardedRoute
            isLogged={true}
            canVisit={true}
            path={ROUTES.ACCEPT_REQ}
            component={RedirectingPageAccept}
          />

          <RoleGuardedRoute
            isLogged={true}
            canVisit={true}
            path={ROUTES.REJECT_REQ}
            component={RedirectingPageReject}
          />

          {/* admin routes */}
          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isAdmin}
            path={ROUTES.MANAGE_LEGISLATION}
            component={LegislationAdmin}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isAdmin}
            path={ROUTES.MANAGE_ACCOUNTS}
            component={AccountsAdmin}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isAdmin}
            exact
            path={ROUTES.MANAGE_NOTIFICATIONS}
            component={NotificationsAdmin}
          />

          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            path={ROUTES.LITIGATION_DOWNLOAD}
            component={LitigationDocument}
          />
          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            path={ROUTES.CCR_REPORT}
            component={CcrReport}
            type={'CcrReport'}
          />
          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            path={ROUTES.ADDITIONAL_DOCUMENT}
            component={CcrReport}
            type={'AdditionalDocuments'}
          />
          <RoleGuardedRoute
            isLogged={!!session}
            canVisit={isPrincipalAccount || isSecondaryAccount}
            path={ROUTES.FOLLOW_UP_CCR_REPORT}
            component={CcrReport}
            type={'FollowupCcrReport'}
          />
        </Switch>
      </Layout>
    </BrowserRouter>
  );
};

export default Router;
